import { Divider } from 'antd'
import {
  DraggingStyle,
  DroppableProvided,
  DroppableStateSnapshot,
  NotDraggingStyle
} from 'react-beautiful-dnd'
import { MovePlayersPlayerWithTeamInfo } from 'src/types/type'

import PlayerDraggableListItem from './PlayerDraggableListItem'

type GroupedPlayerList = Record<string, MovePlayersPlayerWithTeamInfo[]>

interface PlayerListDisplayProps {
  playerList: GroupedPlayerList
  searchPlayerQuery: string
  snapshot: DroppableStateSnapshot
  provided: DroppableProvided
  getItemStyle: (
    isDragging: boolean,
    draggableStyle: DraggingStyle | NotDraggingStyle | undefined
  ) => React.CSSProperties
}

function PlayerListDisplay(props: Readonly<PlayerListDisplayProps>) {
  const { playerList, searchPlayerQuery, snapshot, provided, getItemStyle } =
    props
  return (
    <>
      {(() => {
        if (Object.entries(playerList).length > 0) {
          return Object.entries(playerList).map(([teamName, students]) => (
            <div className="player-list-wrapper" key={teamName}>
              <Divider
                className="player-list-divider"
                orientation="left"
                orientationMargin="0"
              >
                {teamName}
              </Divider>
              <ul className="player-list">
                <li
                  className={`player-tiles-placeholder ${
                    snapshot.isDraggingOver ? 'dragging-over' : ''
                  }`}
                >
                  <h5 className="fw-bold">
                    {snapshot.isDraggingOver ? 'This Section is dragged' : ''}
                  </h5>
                </li>
                {students.map((student: MovePlayersPlayerWithTeamInfo) => (
                  <PlayerDraggableListItem
                    key={student.id}
                    student={student}
                    getItemStyle={getItemStyle}
                  />
                ))}
                {provided.placeholder}
              </ul>
            </div>
          ))
        }
        if (searchPlayerQuery.length !== 0) {
          return 'No matches found'
        }
        return ''
      })()}
    </>
  )
}

export default PlayerListDisplay
